export function addProduct(
  producto,
  cantidad,
  precio,
  igv,
  setData,
  setProducto,
  setCantidad,
  setPrecio,
  idUsuario
) {
  const product = {
    idPServicio: producto.value,
    cantidad: cantidad,
    precio: parseFloat(precio),
    igv: igv ? "S" : "N",
    dscto01: 0,
    dscto02: 0,
    dsctoImporte: 0,
    subtotal: cantidad * precio,
    importe: cantidad * precio * (igv ? 1.18 : 1),
    idUsuario: idUsuario || "",
    nombreAlternativo: producto.label,
  };
  setData((prevData) => [...prevData, product]);
  setProducto(null);
  setCantidad(0);
  setPrecio(0);
}

export const deleteIGVDefault = (rowIndex, setData) => {
  setData((prevData) =>
    prevData.map((item, index) => {
      if (index === rowIndex) {
        const subtotal = item.cantidad * item.precio;
        const totalAntesDescuento =
          item.igv === "N" ? subtotal * 1.18 : subtotal;
        const dsctoImporte = totalAntesDescuento * (item.dscto01 / 100);
        const importeFinal = totalAntesDescuento * (1 - item.dscto01 / 100);

        return {
          ...item,
          igv: item.igv === "S" ? "N" : "S",
          dsctoImporte: dsctoImporte,
          importe: importeFinal,
        };
      }
      return item;
    })
  );
};

export const deleteProductDefault = (index, setData) => {
  setData((prevData) => prevData.filter((_, i) => i !== index));
};

export const setValueTableDefault = (row, setData) => {
  setData((prevData) =>
    prevData.map((item, index) => {
      if (index === row.rowIndex) {
        let newValue =
          row.columnKey === "nombreAlternativo"
            ? row.inputValue
            : Math.max(0, parseFloat(row.inputValue)) || 0;

        const updatedItem = {
          ...item,
          [row.columnKey]: newValue,
        };

        return {
          idPServicio: updatedItem.idPServicio,
          cantidad: updatedItem.cantidad,
          precio: updatedItem.precio,
          igv: updatedItem.igv,
          dscto01: updatedItem.dscto01,
          dscto02: updatedItem.dscto02,
          subtotal: updatedItem.cantidad * updatedItem.precio,
          dsctoImporte:
            updatedItem.cantidad *
            updatedItem.precio *
            (updatedItem.dscto01 / 100),
          importe:
            updatedItem.igv === "S"
              ? (updatedItem.cantidad * updatedItem.precio -
                  updatedItem.cantidad *
                    updatedItem.precio *
                    (updatedItem.dscto01 / 100)) *
                1.18
              : updatedItem.cantidad * updatedItem.precio -
                updatedItem.cantidad *
                  updatedItem.precio *
                  (updatedItem.dscto01 / 100),
          idUsuario: updatedItem.idUsuario,
          nombreAlternativo: updatedItem.nombreAlternativo,
        };
      }
      return item;
    })
  );
};

export function calculateAmountsVenta(maestro, data, descuento) {
  if (typeof maestro !== "object" || maestro === null) {
    throw new Error("`maestro` debe ser un objeto válido");
  }

  if (!Array.isArray(data)) {
    throw new Error("`data` debe ser un arreglo");
  }

  if (typeof descuento !== "number" && typeof descuento !== "string") {
    throw new Error("`descuento` debe ser un número o string numérico");
  }

  const IGV_RATE = 0.18;

  maestro.impAfecto = data.reduce(
    (acc, item) =>
      item.igv === "S" ? acc + item.importe / (1 + IGV_RATE) : acc,
    0
  );

  maestro.impInafecto = data.reduce(
    (acc, item) => (item.igv === "N" ? acc + item.importe : acc),
    0
  );
  
  maestro.dsctTasa01 = Number(descuento) || 0;

  maestro.dsctImp01 = maestro.impAfecto * (maestro.dsctTasa01 / 100); 

  const baseNeta = maestro.impAfecto - maestro.dsctImp01;

  const igvMonto = baseNeta * IGV_RATE;

  maestro.impTotal = baseNeta + maestro.impInafecto + igvMonto;

  maestro._base = maestro.impAfecto + maestro.impInafecto;
  maestro.impuesto = igvMonto;
  maestro.impDsctoTotal = maestro.dsctImp01;
  maestro.numItems = data.length;

  return maestro;
}

//VERSION ANTERIOR DE calculateAmountsVenta
// if (typeof maestro !== "object" || maestro === null) {
//     throw new Error("`maestro` debe ser un objeto válido");
//   }

//   if (!Array.isArray(data)) {
//     throw new Error("`data` debe ser un arreglo");
//   }

//   if (typeof descuento !== "number" && typeof descuento !== "string") {
//     throw new Error("`descuento` debe ser un número o string numérico");
//   }

//   maestro.impAfecto = data.reduce(
//     (acc, item) => (item.igv === "S" ? acc + item.importe / 1.18 : acc),
//     0
//   );

//   maestro.impInafecto = data.reduce(
//     (acc, item) => (item.igv === "N" ? acc + item.importe : acc),
//     0
//   );

//   const IGV_RATE = 0.18;
//   maestro.impAfecto = data.reduce(
//     (acc, item) =>
//       item.igv === "S" ? acc + item.importe / (1 + IGV_RATE) : acc,
//     0
//   );

//   maestro.impInafecto = data.reduce(
//     (acc, item) => (item.igv === "N" ? acc + item.importe : acc),
//     0
//   );

//   const igvMonto = maestro.impAfecto * IGV_RATE;

//   maestro._base = maestro.impAfecto + maestro.impInafecto;

//   maestro.dsctTasa01 = Number(descuento) || 0;
//   maestro.dsctImp01 = maestro._base * (maestro.dsctTasa01 / 100);
//   maestro.impDsctoTotal = maestro.dsctImp01;

//   maestro.impTotal = maestro._base + igvMonto - maestro.dsctImp01;

//   maestro.impuesto = igvMonto;
//   maestro.numItems = data.length;

//   return maestro;

export function calculateAmountsCompra(
  maestro,
  data,
  descuento,
  flete,
  percepcion
) {
  if (typeof maestro !== "object" || maestro === null) {
    throw new Error("`maestro` debe ser un objeto válido");
  }

  if (!Array.isArray(data)) {
    throw new Error("`data` debe ser un arreglo");
  }

  if (typeof descuento !== "number" && typeof descuento !== "string") {
    throw new Error("`descuento` debe ser un número o string numérico");
  }

  const IGV_RATE = 0.18;

  maestro.flete = Number(flete) || 0;
  maestro.percepciones = Number(percepcion) || 0;

  // Calcular impAfecto sin IGV
  maestro.impAfecto = data.reduce(
    (acc, item) =>
      item.igv === "S" ? acc + item.importe / (1 + IGV_RATE) : acc,
    0
  );

  maestro.impInafecto = data.reduce(
    (acc, item) => (item.igv === "N" ? acc + item.importe : acc),
    0
  );

  // Descuento solo sobre lo afecto
  maestro.dsctTasa01 = Number(descuento) || 0;
  maestro.dsctImp01 = maestro.impAfecto * (maestro.dsctTasa01 / 100);

  const baseNeta = maestro.impAfecto - maestro.dsctImp01;

  // IGV se calcula sobre la base neta
  const igvMonto = baseNeta * IGV_RATE;

  maestro.impTotal =
    baseNeta +
    maestro.impInafecto +
    igvMonto +
    maestro.flete +
    maestro.percepciones;

  maestro._base = maestro.impAfecto + maestro.impInafecto;
  maestro.impuesto = igvMonto;
  maestro.impDsctoTotal = maestro.dsctImp01;
  maestro.numItems = data.length;

  return maestro;
}
